// src/utils/cap-arengas-anon.js — cap de escuchas de arenga para el usuario
// ANÓNIMO (sin login). CONSTRUIDO APAGADO: el gating efectivo depende del flag
// `cap_arengas_anon` en la base (RPC anon `getCapArengasAnon` en core/tribuna.js).
// Con el flag OFF (default y estado actual) NADA de esto aplica — el anónimo
// escucha sin límite.
//
// El conteo vive en localStorage (no hay cuenta para el anónimo). Se cuentan
// arengas DISTINTAS por `audio_id`: re-escuchar una ya contada NO suma. Al
// alcanzar el límite, el próximo intento de escuchar una arenga NUEVA muestra el
// cartel unificado "Entrá a jugar".
//
// El límite es una CONSTANTE del front (decisión arquitecto): el flag de la base
// solo dice enabled on/off; el número de tope no viaja por la base.
//
// Cómo prender/apagar la feature y cómo cambiar el número: ver
// docs/ACTIVAR_LIMITE_5_ARENGAS_SIN_LOGIN.md (única fuente, orientada al dueño).

export const CAP_ARENGAS_ANON_LIMITE = 5;

const STORAGE_KEY = 'pm_cap_arengas_anon';

// Lee el set de audio_ids ya escuchados. Defensivo: storage inaccesible
// (incógnito estricto, SSR) o JSON corrupto → set vacío.
const leerSet = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return new Set();
    const arr = JSON.parse(raw);
    return Array.isArray(arr) ? new Set(arr) : new Set();
  } catch (_) {
    return new Set();
  }
};

const guardarSet = (set) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify([...set]));
  } catch (_) { /* storage no disponible: el cap degrada a permisivo */ }
};

export const escuchadasAnon = () => leerSet().size;

export const yaEscuchadaAnon = (audioId) => leerSet().has(audioId);

// Registra una escucha distinta (idempotente). Devuelve el total tras registrar.
export const registrarEscuchaAnon = (audioId) => {
  const set = leerSet();
  if (audioId && !set.has(audioId)) {
    set.add(audioId);
    guardarSet(set);
  }
  return set.size;
};

// ¿El anónimo puede escuchar ESTA arenga ahora?
//   - flag OFF (!enabled)        → siempre permitido (comportamiento actual).
//   - audioId vacío              → permitido (no podemos contar lo que no tiene id).
//   - arenga ya escuchada        → permitido (re-escuchar es libre, no recuenta).
//   - arenga nueva + bajo tope   → permitido.
//   - arenga nueva + tope lleno  → BLOQUEADO.
// No decide nada sobre el usuario logueado: el cap solo aplica a anónimo y eso
// lo resuelve el caller (no llama a esta función si hay sesión).
export const puedeEscucharArengaAnon = (audioId, flag) => {
  if (!flag || !flag.enabled) return true;
  if (!audioId) return true;
  if (yaEscuchadaAnon(audioId)) return true;
  const limite = Number.isFinite(flag?.limit) ? flag.limit : CAP_ARENGAS_ANON_LIMITE;
  return escuchadasAnon() < limite;
};
